import { 
  Cookie as CookieIcon, 
  ChevronDown, 
  ChevronUp, 
  Check, 
  BarChart3, 
  Megaphone, 
  X, 
  Settings, 
  Info, 
  Shield 
} from 'lucide-react';

// iconComponents.tsx
export const iconComponent = {
  // Empathic Design - Hand holding heart
  "empathic-design": ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 256 256" fill="currentColor">
      <path d="M199.77344,125.2334,149.3457,106.6543,130.7666,56.22656a19.9996,19.9996,0,0,0-37.5332,0L74.6543,106.6543,24.22656,125.2334a19.9996,19.9996,0,0,0,0,37.5332L74.6543,181.3457l18.5791,50.42774a19.9996,19.9996,0,0,0,37.5332,0l18.5791-50.42774,50.42774-18.5791a19.9996,19.9996,0,0,0,0-37.5332Zm-60.45606,34.22949a19.97179,19.97179,0,0,0-11.85449,11.85449l.001-.001L112,213.28906,96.53711,171.31738a19.96863,19.96863,0,0,0-11.85352-11.85351L42.71094,144l41.97168-15.46289a19.96863,19.96863,0,0,0,11.85351-11.85352L112,74.71094l15.46289,41.97168a19.96863,19.96863,0,0,0,11.85352,11.85351L181.28906,144ZM140,40a12.0006,12.0006,0,0,1,12-12h12V16a12,12,0,0,1,24,0V28h12a12,12,0,0,1,0,24H188V64a12,12,0,0,1-24,0V52H152A12.0006,12.0006,0,0,1,140,40ZM252,88a12.0006,12.0006,0,0,1-12,12h-4v4a12,12,0,0,1-24,0v-4h-4a12,12,0,0,1,0-24h4V72a12,12,0,0,1,24,0v4h4A12.0006,12.0006,0,0,1,252,88Z" />
    </svg>
  ),

  // Smart Indicators - Dashboard gauge
  "smart-indicators": ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 256 256" fill="currentColor">
      <path d="M249.27832,87.6084c.12354-.15039.23145-.30908.34668-.46387.11816-.15869.24121-.31348.35156-.478.12012-.18017.2251-.3667.335-.55127.08985-.15185.18555-.2998.269-.456.09961-.18555.18408-.377.27343-.56689.07764-.16553.16016-.32764.23047-.49756.07666-.18457.13867-.37354.20557-.561.06494-.18164.13476-.36084.19141-.54687.05712-.189.0996-.38135.14746-.57325.04687-.188.10009-.374.13818-.56543.04395-.22168.07031-.44482.10156-.668.02344-.165.05518-.32666.07129-.49366a12.042,12.042,0,0,0,0-2.373c-.01611-.167-.04785-.32862-.07129-.49366-.03125-.22314-.05761-.44628-.10156-.668-.03809-.19141-.09131-.37745-.13818-.56543-.04786-.1919-.09034-.38428-.14746-.57373-.05665-.18555-.12647-.36475-.19141-.54639-.0669-.1875-.12891-.37647-.20557-.56152-.07031-.16944-.15283-.33155-.231-.49708-.08887-.18994-.17334-.38134-.273-.56689-.0835-.15625-.1792-.3042-.269-.456-.10986-.18457-.21484-.3711-.335-.55127-.11035-.16455-.2334-.31934-.35156-.478-.11523-.15479-.22314-.31348-.34668-.46387-.22412-.27295-.46289-.53271-.71-.78467-.02881-.02978-.05322-.0625-.083-.09228l-40-40a12.0001,12.0001,0,0,0-16.9707,16.9707L211.0293,68H176a60.06812,60.06812,0,0,0-60,60,36.04178,36.04178,0,0,1-33.86475,35.93115,39.99529,39.99529,0,1,0,.042,24.01367A60.0622,60.0622,0,0,0,140,128a36.04061,36.04061,0,0,1,36-36h35.0293l-19.51465,19.51465a12.0001,12.0001,0,0,0,16.9707,16.9707l40-40c.02979-.02978.0542-.0625.083-.09228C248.81543,88.14111,249.0542,87.88135,249.27832,87.6084ZM44,192a16,16,0,1,1,16-16A16.01833,16.01833,0,0,1,44,192Z" />
    </svg>
  ),

  // Smart Data Flows - Network flow
  "smart-data-flows": ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 256 256" fill="currentColor">
      <path d="M241.45557,30.544a36.04236,36.04236,0,0,0-50.91114,0H190.544a36.04491,36.04491,0,0,0-1.19983,49.64941L165.51538,124.4458a36.16015,36.16015,0,0,0-21.02588,3.07275l-16.008-16.00781A35.99677,35.99677,0,0,0,70.54443,70.544H70.544a36.04479,36.04479,0,0,0-1.19971,49.64941L45.51538,164.4458A35.9677,35.9677,0,0,0,14.54443,174.544H14.544a36.00029,36.00029,0,1,0,52.11193,1.26269L90.48462,131.5542a36.013,36.013,0,0,0,21.026-3.07275l16.00793,16.00781a35.99753,35.99753,0,1,0,59.13733-8.68262L210.48462,91.5542A36.25377,36.25377,0,0,0,216,91.98242,35.98219,35.98219,0,0,0,241.45557,30.544ZM87.51416,87.51465A12.00036,12.00036,0,0,1,104.488,104.48291l-.00269.00244-.0022.00244a12.00018,12.00018,0,0,1-16.9685-16.97314ZM48.48584,208.48535a12.00027,12.00027,0,0,1-16.97119-16.9707h-.00049a12.00044,12.00044,0,0,1,16.97168,16.9707Zm120-40a12.00027,12.00027,0,0,1-16.97119-16.9707l.0022-.00244a12.00036,12.00036,0,0,1,16.969,16.97314Zm56-104a12.00027,12.00027,0,0,1-16.97119-16.9707h-.00049a12.00044,12.00044,0,0,1,16.97168,16.9707Z" />
    </svg>
  ),

  // Flow Optimization - Lightning bolt
  "flow-optimization": ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 256 256" fill="currentColor">
      <path d="M95.99561,251.99268a12.001,12.001,0,0,1-11.7627-14.354l13.999-69.99365L43.78662,147.228a11.99964,11.99964,0,0,1-4.55908-19.42383l112-120a12,12,0,0,1,20.53955,10.5415l-13.999,69.99366,54.44531,20.417a11.99964,11.99964,0,0,1,4.55908,19.42383l-112,120A11.9949,11.9949,0,0,1,95.99561,251.99268ZM69.01953,131.05859l47.19385,17.69776a11.99972,11.99972,0,0,1,7.55371,13.58935l-7.71533,38.5752,70.92871-75.99512L139.78662,107.228a11.99973,11.99973,0,0,1-7.55371-13.58936l7.71533-38.57519Z" />
    </svg>
  ),

  // Multiple Workspaces - Grid layout
  "multiple-workspaces": ({ className }: { className?: string }) => (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),

  // AI Agents - Robot
  "ai-agents": ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 256 256" fill="currentColor">
      <path d="M200,44H140V16a12,12,0,0,0-24,0V44H56A36.04061,36.04061,0,0,0,20,80V192a36.04061,36.04061,0,0,0,36,36H200a36.04061,36.04061,0,0,0,36-36V80A36.04061,36.04061,0,0,0,200,44Zm12,148a12.01343,12.01343,0,0,1-12,12H56a12.01343,12.01343,0,0,1-12-12V80A12.01343,12.01343,0,0,1,56,68H200a12.01343,12.01343,0,0,1,12,12Zm-40-60H84a28.03146,28.03146,0,0,0-28,28v4a28.03146,28.03146,0,0,0,28,28h88a28.03146,28.03146,0,0,0,28-28v-4A28.03146,28.03146,0,0,0,172,132Zm-36,24v12H120V156Zm-56,8v-4a4.00427,4.00427,0,0,1,4-4H96v12H84A4.00427,4.00427,0,0,1,80,164Zm96,0a4.00427,4.00427,0,0,1-4,4H160V156h12a4.00427,4.00427,0,0,1,4,4ZM68,104a16,16,0,1,1,16,16A16.00008,16.00008,0,0,1,68,104Zm88,0a16,16,0,1,1,16,16A16.00008,16.00008,0,0,1,156,104Z" />
    </svg>
  ),

  // Table Intelligence - Smart table
  "table-intelligence": ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 4v4h6V8H5m8 0v4h6V8h-6m-8 6v4h6v-4H5m8 0v4h6v-4h-6z" />
    </svg>
  ),

  // AI Predictions - Crystal ball
  "ai-predictions": ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 256 256" fill="currentColor">
      <path d="M228.749,100.04687c-3.51562-3.666-7.15136-7.457-8.33789-10.32421-1.06152-2.56739-1.1416-7.82911-1.21191-12.47071-.15039-9.998-.33887-22.44043-9.17481-31.27636s-21.27832-9.02442-31.27636-9.17481c-4.6416-.07031-9.90332-.15039-12.47071-1.21191-2.86718-1.18653-6.6582-4.82227-10.32324-8.33789C148.86816,20.45605,140.05078,12,128,12c-12.0498,0-20.86816,8.45605-27.95312,15.251-3.666,3.51562-7.457,7.15136-10.32422,8.33789-2.56739,1.06152-7.82911,1.1416-12.47071,1.21191-9.998.15039-22.44043.33887-31.27636,9.17481s-9.02442,21.27832-9.17481,31.27636c-.07031,4.6416-.15039,9.90332-1.21191,12.47071-1.18653,2.86718-4.82227,6.6582-8.33789,10.32324C20.45605,107.13184,12,115.94922,12,128c0,12.0498,8.45605,20.86816,15.251,27.95312,3.51562,3.666,7.15136,7.457,8.33789,10.32422,1.06152,2.56739,1.1416,7.82911,1.21191,12.47071.15039,9.998.33887,22.44043,9.17481,31.27636s21.27832,9.02442,31.27636,9.17481c4.6416.07031,9.90332.15039,12.47071,1.21191,2.86718,1.18653,6.6582,4.82227,10.32324,8.33789C107.13184,235.544,115.94922,244,128,244c12.0498,0,20.86816-8.45605,27.95313-15.251,3.666-3.51562,7.457-7.15136,10.32421-8.33789,2.56739-1.06152,7.82911-1.1416,12.47071-1.21191,9.998-.15039,22.44043-.33887,31.27636-9.17481s9.02442-21.27832,9.17481-31.27636c.07031-4.6416.15039-9.90332,1.21191-12.47071,1.18653-2.86718,4.82227-6.6582,8.33789-10.32324C235.544,148.86816,244,140.05078,244,128,244,115.9502,235.544,107.13184,228.749,100.04687ZM211.42676,139.3418c-4.81738,5.02343-10.27832,10.71777-13.19141,17.75976-2.81445,6.80078-2.92578,14.16309-3.0332,21.28418-.08106,5.36426-.19141,12.71192-2.14844,14.668-1.95605,1.957-9.30371,2.06738-14.668,2.14844-7.12109.10742-14.4834.21875-21.28418,3.0332-7.042,2.91309-12.73633,8.374-17.75976,13.19141C135.78125,214.84082,130.40234,220,128,220s-7.78223-5.15918-11.3418-8.57324c-5.02343-4.81739-10.71777-10.27832-17.75976-13.19141-6.80078-2.81445-14.16309-2.92578-21.28418-3.0332-5.36426-.08106-12.71192-.19141-14.668-2.14844-1.957-1.95605-2.06738-9.30371-2.14844-14.668-.10742-7.12109-.21875-14.4834-3.0332-21.28418-2.91309-7.042-8.374-12.73633-13.19141-17.75976C41.15918,135.78125,36,130.40234,36,128s5.15918-7.78223,8.57324-11.3418c4.81739-5.02343,10.27832-10.71777,13.19141-17.75976,2.81445-6.80078,2.92578-14.16309,3.0332-21.28418.08106-5.36426.19141-12.71192,2.14844-14.668,1.956-1.957,9.30371-2.06738,14.668-2.14844,7.12109-.10742,14.4834-.21875,21.28418-3.0332,7.042-2.91309,12.73633-8.374,17.75976-13.19141C120.21875,41.15918,125.59766,36,128,36s7.78223,5.15918,11.3418,8.57324c5.02343,4.81738,10.71777,10.27832,17.75976,13.19141,6.80078,2.81445,14.16309,2.92578,21.28418,3.0332,5.36426.08106,12.71192.19141,14.668,2.14844,1.957,1.956,2.06738,9.30371,2.14844,14.668.10742,7.12109.21875,14.4834,3.0332,21.28418,2.91309,7.042,8.374,12.73633,13.19141,17.75976C214.84082,120.21875,220,125.59766,220,128S214.84082,135.78223,211.42676,139.3418ZM115.999,132V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0Zm28.00049,40a16,16,0,1,1-16-16A16.00016,16.00016,0,0,1,143.99951,172Z" />
    </svg>
  ),

  // Export Magic - Share/Export with click indicator
  "export-magic": ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 256 256" fill="currentColor">
      <path d="M77.51367,66.47363a12.00063,12.00063,0,0,1,.00195-16.9707l42-41.98926a11.99917,11.99917,0,0,1,16.96875,0l42,41.98926a12.0001,12.0001,0,0,1-16.96875,16.97266L140,44.96558V128a12,12,0,0,1-24,0V44.96558l-21.51563,21.51A12.00063,12.00063,0,0,1,77.51367,66.47363ZM200,88H176a12,12,0,0,0,0,24h20v92H60V112H80a12,12,0,0,0,0-24H56a20.0226,20.0226,0,0,0-20,20V208a20.0226,20.0226,0,0,0,20,20H200a20.0226,20.0226,0,0,0,20-20V108A20.0226,20.0226,0,0,0,200,88Z" />
    </svg>
  ),

  // Other icons
  play: ({ className }: { className?: string }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M8 5v14l11-7z" />
    </svg>
  ),

  pause: ({ className }: { className?: string }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
    </svg>
  ),

  arrowRight: ({ className }: { className?: string }) => (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 8l4 4m0 0l-4 4m4-4H3"
      />
    </svg>
  ),

  share: ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 256 256" fill="currentColor">
      <path d="M176,156a43.80846,43.80846,0,0,0-29.09375,11.032l-40.81006-26.2351a43.9604,43.9604,0,0,0,0-25.59375L146.90625,88.968a43.88869,43.88869,0,1,0-13.00244-20.17188L93.09326,95.03149a44,44,0,1,0,0,65.937l40.81055,26.23535A43.99884,43.99884,0,1,0,176,156Zm0-120a20,20,0,1,1-20,20A20.02229,20.02229,0,0,1,176,36ZM64,148a20,20,0,1,1,20-20A20.02229,20.02229,0,0,1,64,148Zm112,72a20,20,0,1,1,20-20A20.02229,20.02229,0,0,1,176,220Z" />
    </svg>
  ),

  // Cookie icon - Lucide Cookie Icon
  cookie: ({ className }: { className?: string }) => (
    <CookieIcon className={className} />
  ),

  // Chevron Down - Lucide Icon
  chevronDown: ({ className }: { className?: string }) => (
    <ChevronDown className={className} />
  ),

  // Chevron Up - Lucide Icon
  chevronUp: ({ className }: { className?: string }) => (
    <ChevronUp className={className} />
  ),

  // Shield with checkmark - Lucide Icon
  shield: ({ className }: { className?: string }) => (
    <Shield className={className} />
  ),

  // Check/Checkmark - Lucide Icon
  check: ({ className }: { className?: string }) => (
    <Check className={className} />
  ),

  // Settings/Gear icon - Lucide Icon
  settings: ({ className }: { className?: string }) => (
    <Settings className={className} />
  ),

  // Info circle - Lucide Icon
  info: ({ className }: { className?: string }) => (
    <Info className={className} />
  ),

  // Analytics/Chart icon - Lucide Icon
  analytics: ({ className }: { className?: string }) => (
    <BarChart3 className={className} />
  ),

  // Marketing/Megaphone icon - Lucide Icon
  marketing: ({ className }: { className?: string }) => (
    <Megaphone className={className} />
  ),

  // Privacy/Lock icon - Lucide Icon
  privacy: ({ className }: { className?: string }) => (
    <Shield className={className} />
  ),

  // X/Close icon - Lucide Icon
  x: ({ className }: { className?: string }) => (
    <X className={className} />
  ),
};
